import { Injectable } from '@angular/core'
import { Logger } from 'common/log'
import { Subject } from 'rxjs'

const logger = new Logger('http')

@Injectable({ providedIn: 'root' })
export class HttpInterceptorService {
  enableSessionExpiryDetection = true
  sessionExpired$ = new Subject<void>()

  processResponse (request: Request, response: Response): Response {
    if (!response.ok) {
      return this.processError(response)
    }

    console.log(
      `%c${response.status}`,
      'color: ' + (response.status >= 200 && response.status < 300 ? '#080' : '#800'),
      request.method,
      response.url.toString().substring(0, 200),
    )

    return response
  }

  processError (response: Response): Response {
    if (
      !this.enableSessionExpiryDetection ||
      location.pathname.includes('/auth/login') ||
      location.pathname.includes('/auth/password-reset')
    ) {
      return response
    }

    if (response.status === 401) {
      this.sessionExpired$.next()
      this.enableSessionExpiryDetection = false
      location.assign(`/auth/login?next=${location.pathname || '/'}`)
    }

    if (response.status === 500) {
      const infoString = response.headers.get('X-Crash-Info')
      const handled = response.headers.get('X-Crash-Handled')
      if (infoString) {
        const info = JSON.parse(infoString)
        logger.group(response.url)
        if (handled) {
          logger.warn('Handled endpoint error:')
          logger.warn(info.trace)
        } else {
          logger.error('Unhandled server error:')
          logger.error(info.trace)
        }
        logger.log('Worker PID:', info.pid)
        logger.groupEnd()
      }
    }

    return response
  }
}
